import { BankDossier } from '../../../../api/workOrders/bankDossier';
import { WorkOrderData } from '../../../../api/workOrders/types';
import { Constants } from '../../../../constants/bankDossier';
import {
  BooleanField,
  Field,
  FieldGrid,
  FieldGroup,
  FieldGroups,
  LongTextField,
} from '../../../UI/FieldGrid';

interface SectionProps {
  dossier: BankDossier;
  workOrder: WorkOrderData;
}

const { parties } = Constants;

export function PartiesSection({
  dossier,
  workOrder,
}: SectionProps): JSX.Element {
  const company = dossier.appraisal_company;
  const bank = dossier.requesting_bank;

  return (
    <FieldGroups>
      <FieldGroup title={parties.companyTitle}>
        <FieldGrid minColumn={180}>
          <Field
            label={parties.company.name}
            value={workOrder.worker_company?.name}
            emphasis
            span={2}
          />
          <Field
            label={parties.company.engineer}
            value={workOrder.inspection?.engineer_name}
          />
          <Field
            label={parties.company.escalated}
            value={company.escalated_engineer}
          />
          <Field
            label={parties.company.revisionType}
            value={company.revision_type}
          />
          <Field
            label={parties.company.revisionResponsible}
            value={company.revision_responsible}
          />
          <LongTextField
            label={parties.company.additionalInfo}
            value={company.additional_info}
          />
        </FieldGrid>
      </FieldGroup>

      <FieldGroup title={parties.bankTitle}>
        <FieldGrid minColumn={160}>
          <Field
            label={parties.bank.bank}
            value={workOrder.client_name}
            emphasis
          />
          <Field
            label={parties.bank.requester}
            value={workOrder.requester_name}
          />
          <Field
            label={parties.bank.channel}
            value={dossier.identification.channel}
          />
        </FieldGrid>
      </FieldGroup>

      <FieldGroup title={parties.engineeringTitle}>
        <FieldGrid minColumn={160}>
          <Field
            label={parties.engineering.department}
            value={bank.engineering_department}
            span={2}
          />
          <Field
            label={parties.engineering.analyst}
            value={bank.area_analyst}
          />
          <Field
            label={parties.engineering.manager}
            value={bank.manager_name}
          />
          <BooleanField
            label={parties.engineering.analysis}
            value={bank.requires_bank_engineering_analysis}
            span={2}
          />
        </FieldGrid>
      </FieldGroup>
    </FieldGroups>
  );
}
